//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import styled from 'styled-components';

import { CaptionText } from '@components/atoms/text/Text';

export const ContentCard = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacings[2]};
  flex: 1 0 0;
  border-radius: ${theme.spacings[1]};
`,
);

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const DetailLabel = styled(CaptionText)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.spacings[3]};
`,
);

export const MultiLineValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const CardContainer = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacings[4]};
  width: 100%;
  padding: ${theme.spacings[5]} 0;
  background-color: ${theme.colors.gray00};
  border-radius: ${theme.spacings[1]};
`,
);

export const CardButtonsContainer = styled.div(
  ({ theme }) => `
  display: flex;
  gap: ${theme.spacings[2]};
`,
);
